<template>
    <CreditPicker :value="value" :columns="columns" :title="title" :aria-label="ariaLabel" placeholder="Не задан" :width="470"
                  :disabled="disabled" :has-error="hasError" @input="$emit('input', $event)" @change="$emit('change', $event)" />
</template>

<script>
    import CreditPicker from "./CreditPicker";
    import CreditRequestStatusData from "../../plugins/credit_request_status_data";

    // Выбор статуса кредитной заявки: меню в две колонки, статусы сгруппированы.
    // options — slug'и статусов, доступных пользователю; остальные в меню не показываются.
    export default {
        name: "CreditRequestStatusPicker",
        components: {CreditPicker},
        props: {
            value: {type: String, default: null},
            options: {type: Array, default: () => []},
            title: {type: String, default: ''},
            ariaLabel: {type: String, default: 'Статус'},
            disabled: {type: Boolean, default: false},
            hasError: {type: Boolean, default: false},
        },
        computed: {
            columns() {
                let statuses = CreditRequestStatusData.data();
                let option = slug => ({
                    value: slug,
                    label: statuses[slug].label,
                    markerClass: 'badge-credit-request-status-' + slug,
                    markerText: statuses[slug].short_id,
                });
                let columns = [[], []];
                CreditRequestStatusData.groups().forEach(group => {
                    columns[group.column].push({
                        key: group.key,
                        label: group.label,
                        options: group.statuses.filter(slug => this.options.includes(slug)).map(option),
                    });
                });
                return columns;
            },
        },
    }
</script>
